/* stylelint-disable no-descending-specificity */
import styled, { css } from "styled-components"
import Image from "components/atoms/Image"

const StyledImg = styled(Image)`
  object-fit: cover;
  transition: transform 0.3s linear;
  height: 100%;
  width: 100%;
`
const StyledImgWrapper = styled.div`
  overflow: hidden;
  height: 15rem;
`

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.6rem;
  justify-content: space-between;
  height: 33%;
`
const StyledTypeContainer = styled.div`
  position: absolute;
  top: 0.4rem;
  left: 0.4rem;
  z-index: 1;
  display: flex;
  max-width: calc(100% - 0.8rem);
  flex-wrap: wrap;
`

const StyledType = styled.span`
  height: 2rem;
  text-align: center;
  padding: 0 0.8rem;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 1.67;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.secondary01};
  margin: 0.4rem 0 0 0.4rem;
`

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.white};
  position: relative;

  &:hover ${StyledImg} {
    transform: scale(1.1);
  }

  ${({ type }) =>
    type === "secondary" &&
    css`
      flex-direction: row;
      height: 100%;

      &:before {
        content: "";
        background: ${({ theme }) => theme.color.main03};
        width: calc(100% + 4.8rem);
        height: 0.4rem;
        position: absolute;
        bottom: -0.8rem;
        left: -1.6rem;

        ${({ theme }) => theme.mq.medium} {
          bottom: -2.4rem;
          left: -2.4rem;
        }
      }

      ${StyledImgWrapper} {
        height: 100%;
        position: absolute;
        width: 16rem;
      }

      ${StyledImg} {
        max-width: 14.4rem;
      }

      ${StyledTextWrapper} {
        height: 100%;
        margin-left: 16rem;
        justify-content: flex-start;
      }

      ${StyledTypeContainer} {
        left: 0;
        top: 0;
      }

      ${({ theme }) => theme.mq.medium} {
        flex-direction: column;

        ${StyledImgWrapper} {
          height: 15rem;
          position: relative;
          width: auto;
        }

        ${StyledImg} {
          max-width: initial;
        }

        ${StyledTextWrapper} {
          justify-content: space-between;
          height: 33%;
          margin-left: 0;
        }

        ${StyledTypeContainer} {
          top: 1.6rem;
          left: 1.6rem;
        }
      }
    `}
`

const titleStyles = css`
  display: flex;
  line-height: 1.2;
  overflow: hidden;

  /* stylelint-disable */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  /* stylelint-enable */

  ${({ theme }) => theme.mq.medium} {
    /* stylelint-disable */
    -webkit-line-clamp: 2;
    /* stylelint-enable */
  }
`
const StyledAddress = styled.span`
  display: flex;
  max-width: 368px;
  max-height: 220px;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.s};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.secondary01};
`

const StyledLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.8rem;

  ${({ theme }) => theme.mq.medium} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`
const StyledDetailsLink = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.s};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.main03};

  &:hover {
    color: ${({ theme }) => theme.color.main02};
  }
`

export {
  StyledWrapper,
  StyledImg,
  StyledType,
  StyledTextWrapper,
  titleStyles,
  StyledAddress,
  StyledImgWrapper,
  StyledDetailsLink,
  StyledLineWrapper,
  StyledTypeContainer,
}
